export default async function({ route, store, redirect }) {
  const user = await JSON.parse(localStorage.getItem('user-token')) || null;

  if (!user) {
    return redirect('/login');
  }

  return user !== null;
}
